import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';


class Header extends React.Component {
  static propTypes = {
    title: PropTypes.string,
  };

  static defaultProps = {
    title: '',
  };

  render() {
    const { title } = this.props;
    if (title === '') {
      return null;
    }
    return <Typography variant="h4" component="h1">{title}</Typography>;
  }
}


export default Header;
